'use client'

import './Notify.css'

import { Icon, ICONS, type IconName } from './Icon'
import { notifyContainerActions } from '@/lib/store'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

type notifyProps = {
    type: string
    message: string
    id: number
}

export default function Notify({ type, message, id }: notifyProps) {
    const dispatch = useDispatch()

    let notifyIcon: IconName = ICONS.INFO

    switch (type) {
        case 'success':
            notifyIcon = ICONS.CHECK
            break
        case 'info':
            notifyIcon = ICONS.INFO
            break
        case 'warning':
            notifyIcon = ICONS.ALERT
            break
        case 'error':
            notifyIcon = ICONS.ERROR
            break
        default:
            break
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(notifyContainerActions.removeNotification(id))
        }, 4800)

        return () => clearTimeout(timer)
    }, [])

    return (
        <div
            key={`notify_${id}`}
            className={`notify ${type}`}>
            <Icon name={notifyIcon} />
            <p>{message}</p>
            <div className='progression'></div>
            {/*  <div className='notify-cancle'>
                <Icon
                    name={ICONS.CIRCLE_XMARK}
                    onClick={() => dispatch(notifyContainerActions.removeNotification(id))}
                />
            </div> */}
        </div>
    )
}
